<template>
  <ul class="nav nav-mobile-menu">
    <li class="nav-item">
      <a class="nav-link" @click="logOut">
        <span class="no-icon">Çıkış Yap</span>
      </a>
    </li>
  </ul>
</template>
<script>
  import authorizationService from "../services/authorization.service.js";
  export default {
    name: 'mobile-menu',
    data() {
      return {
      }
    },
    methods: {
      logOut() {
        console.log(authorizationService)
        authorizationService.logOut().then(response => {
          this.$router.push("/signin")
        }).catch(err => {
          console.log(err)
          console.log({ err })
        })
      }
    }
  }
</script>
<style>
</style>